module.exports = __webpack_public_path__ + "static/media/bg2_day.385204c2.png";